/* eslint-disable @typescript-eslint/no-unused-vars */
import { Button } from "antd";
import React, { useState } from "react";
import DeathCertificate from "../../components/sections/deathCertificate";
import PoliceReport from "../../components/sections/policeReport";
import Affidavits from "../../components/sections/affidavits";
import NationalId from "../../components/sections/nationalId";
import { useAppState } from "../../context/app-state-provider";
import Dischargeslip from "../../components/sections/dischargeslip";
import HospitalInvoice from "../../components/sections/hospitalInvoice";
import ExcuseDuty from "../../components/sections/excuseDuty";

export default function Uploads(props: any) {
  const { api, contextHolder } = useAppState();
  const [deathCertificate, setDeathCertificate] = useState<any>(null);
  const [policeReport, setPoliceReport] = useState<any>(null);
  const [affidavits, setAffidavits] = useState<any>(null);
  const [nationalId, setNationalId] = useState<any>(null);
  const [done, setDone] = useState<boolean>(false);

  const [hospitalInvoice, setHospitalInvoice] = useState<any>(null);
  const [excuseDuty, setExcuseDuty] = useState<any>(null);
  const [dischargeslip, setDischargeslip] = useState<any>(null);

  function _onProceed() {
    if (props.persist.type === "Death" && !deathCertificate) {
      return api["warning"]({
        message: "Death Certificate",
        description: "Upload a Death Certificate",
      });
    }

    if (!nationalId) {
      return api["warning"]({
        message: "National ID",
        description: "Upload a National ID",
      });
    }

    if (props.persist.type === "Hospitalized" && !hospitalInvoice) {
      return api["warning"]({
        message: "Hospital Invoice",
        description: "Upload a Hospital Invoice",
      });
    }

    if (props.persist.type === "Hospitalized" && !dischargeslip) {
      return api["warning"]({
        message: "Discharge Slip",
        description: "Upload a Discharge Slip",
      });
    }

    if (props.persist.type === "Hospitalized" && !excuseDuty) {
      return api["warning"]({
        message: "Excuse Duty",
        description: "Upload an Excuse Duty document",
      });
    }

    props.setPersist({
      ...props.persist,
      deathCertificate,
      policeReport,
      affidavits,
      nationalId,
      hospitalInvoice,
      dischargeslip,
      excuseDuty,
    });
    props.setTab(3);
  }

  const goBackHandler = () => {
    props.setTab(0); // Navigate back one step in history
  };

  return (
    <div className="w-full flex justify-center px-4">
      <div className="w-full max-w-5xl">
        <h2 className="font-semibold text-lg text-center text-neutral-900 mb-1">
          Upload your documents
        </h2>
        <p className="text-sm text-neutral-500 text-center mb-6">
          {props.persist.type === "Death"
            ? "We need these documents to process a death claim."
            : "We need these documents to process a hospitalization claim."}
        </p>
        {props.persist.type === "Death" ? (
          <div className="flex flex-wrap gap-4 justify-center w-full">
            <div className="w-full sm:w-auto">
              <DeathCertificate setDeathCertificate={setDeathCertificate} />
            </div>
            <div className="w-full sm:w-auto">
              <PoliceReport setPoliceReport={setPoliceReport} />
            </div>
            <div className="w-full sm:w-auto">
              <Affidavits setAffidavits={setAffidavits} />
            </div>
            <div className="w-full sm:w-auto">
              <NationalId setNationalId={setNationalId} />
            </div>
          </div>
        ) : (
          <div className="flex flex-wrap gap-4 justify-center w-full">
            <div className="w-full sm:w-auto">
              <Dischargeslip setDischargeslip={setDischargeslip} />
            </div>
            <div className="w-full sm:w-auto">
              <HospitalInvoice setHospitalInvoice={setHospitalInvoice} />
            </div>
            <div className="w-full sm:w-auto">
              <ExcuseDuty setExcuseDuty={setExcuseDuty} />
            </div>
            <div className="w-full sm:w-auto">
              <NationalId setNationalId={setNationalId} />
            </div>
          </div>
        )}

        <div className="flex flex-col items-center gap-3 mt-6 mb-6">
          <Button
            onClick={_onProceed}
            type="primary"
            size="large"
            style={{ backgroundColor: "#06509E" }}
            className="w-full sm:w-[30rem] text-white"
          >
            Proceed
          </Button>
          <Button
            onClick={goBackHandler}
            size="large"
            className="w-full sm:w-[30rem]"
          >
            Back
          </Button>
        </div>
      </div>
      {contextHolder}
    </div>
  );
}
